import {
  Zap, Shield, ShieldCheck, Globe, HardDrive, Mail, Headphones, Server,
  Users, Lock, Database, LifeBuoy, Sparkles, Cpu, Gauge, Cloud, RefreshCw,
  Award, Rocket, Star, TrendingUp, Check, Wifi, Activity, Layers,
  type LucideIcon,
} from "lucide-react";

export const HOSTING_ICONS: Record<string, LucideIcon> = {
  Zap, Shield, ShieldCheck, Globe, HardDrive, Mail, Headphones, Server,
  Users, Lock, Database, LifeBuoy, Sparkles, Cpu, Gauge, Cloud, RefreshCw,
  Award, Rocket, Star, TrendingUp, Check, Wifi, Activity, Layers,
};

export const HOSTING_ICON_NAMES = Object.keys(HOSTING_ICONS);

export function resolveHostingIcon(name?: string | null): LucideIcon {
  if (!name) return Sparkles;
  return HOSTING_ICONS[name] ?? Sparkles;
}
